import { useSetAccountPrimaryPhoneNumberMutation } from "@apis/accounts/useAccounts"
import { accountKeys } from "@apis/accounts/queryKeys"
import { prospectsKeys } from "@apis/prospects/queryKeys"
import type { IProspectPhone } from "@apis/prospects/types"
import { Button } from "@components/ui/button"
import { useQueryClient } from "@tanstack/react-query"
import { Loader2 } from "lucide-react"
import { toast } from "sonner"

type TSetAccountPrimaryPhoneNumberButtonProps = {
  prospectPhoneNumber: IProspectPhone
  accountId: string
}
export const SetAccountPrimaryPhoneNumberButton = ({
  prospectPhoneNumber,
  accountId,
}: TSetAccountPrimaryPhoneNumberButtonProps) => {
  const queryClient = useQueryClient()
  const setAccountPrimaryPhoneNumber = useSetAccountPrimaryPhoneNumberMutation()
  const handleClick = () => {
    setAccountPrimaryPhoneNumber.mutate(
      {
        account_id: accountId,
        request: {
          membership_profile_phone: {
            primary_phone: prospectPhoneNumber.phone,
          },
          is_primary: true,
        },
      },
      {
        onSuccess: () => {
          toast.success("Successfully updated account primary phone number!")
          queryClient.invalidateQueries({
            queryKey: prospectsKeys.prospectPhoneNumbers(
              prospectPhoneNumber.prospect_guid,
            ),
          })
          queryClient.invalidateQueries({
            queryKey: accountKeys.detail(accountId),
          })
        },
        onError: (error) =>
          toast.error(`Error updating account primary phone number! ${error}`),
      },
    )
  }

  return (
    <Button
      onClick={handleClick}
      size="sm"
      disabled={setAccountPrimaryPhoneNumber.isPending}
    >
      {setAccountPrimaryPhoneNumber.isPending ? (
        <Loader2 className="tw:animate-spin" />
      ) : (
        <span>Set as primary</span>
      )}
    </Button>
  )
}
